module.exports = __webpack_public_path__ + "img/68f64b9d.1b5b0e08.jpeg";